import { render, staticRenderFns } from "./record.vue?vue&type=template&id=1274a3d4&scoped=true"
import script from "./record.vue?vue&type=script&lang=js"
export * from "./record.vue?vue&type=script&lang=js"
import style0 from "./record.vue?vue&type=style&index=0&id=1274a3d4&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1274a3d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1274a3d4')) {
      api.createRecord('1274a3d4', component.options)
    } else {
      api.reload('1274a3d4', component.options)
    }
    module.hot.accept("./record.vue?vue&type=template&id=1274a3d4&scoped=true", function () {
      api.rerender('1274a3d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportCenter/member/record.vue"
export default component.exports